import type { PropsWithChildren } from 'react';
import type { TextT } from '@mentimeter/ragnar-ui/text';
import { Text } from '@mentimeter/ragnar-ui/text';

export const Label = ({ children, ...props }: PropsWithChildren<TextT>) => {
  return (
    <Text
      color="textWeaker"
      fontSize="150"
      fontWeight="regular"
      lineHeight="none"
      {...props}
    >
      {children}
    </Text>
  );
};
